import { render, staticRenderFns } from "./PaymentDetailsModal.vue?vue&type=template&id=51c71c8a&scoped=true&"
import script from "./PaymentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsModal.vue?vue&type=style&index=0&id=51c71c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c71c8a",
  null
  
)

component.options.__file = "PaymentDetailsModal.vue"
export default component.exports